import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=37ef927e"
import script from "./orderList.vue?vue&type=script&lang=js"
export * from "./orderList.vue?vue&type=script&lang=js"
import style0 from "./orderList.vue?vue&type=style&index=0&id=37ef927e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports